import * as React from "react";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { useLocation, useNavigate } from "react-router-dom";
import api from 'api/axios';
import { Box } from "@mui/material";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import BiotechOutlinedIcon from "@mui/icons-material/BiotechOutlined";
import FunctionsIcon from "@mui/icons-material/Functions";
import ScienceOutlinedIcon from "@mui/icons-material/ScienceOutlined";
import HubOutlinedIcon from "@mui/icons-material/HubOutlined";
import AssignmentIndOutlinedIcon from "@mui/icons-material/AssignmentIndOutlined";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import "./Dashboard.css";
function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();

  const logout = async () => {
    try {
      await api.post("/admin/logout");
    } catch (error) {
      console.error("Logout API failed", error);
    } finally {
      localStorage.clear(); 
      sessionStorage.clear();
      navigate("/login", { replace: true });
      window.location.reload(); 
    }
  };

  const drawer = (
    <List
      sx={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        padding: ".5rem 0 .5rem 0",
        margin: "0 1rem",
        li: {
          borderRadius: "6px",
          overflow: "hidden",
          margin: ".5rem 0",
          svg: { scale: "0.95" },
        },
      }}
    >
      <ListItem
        key={"brand-logo"}
        sx={{
          justifyContent: "center",
        }}
      >
        <img
          src={require("../../assets/images/logo.png")}
          alt="brand-logo"
          height={90}
          width={90}
          style={{ marginBottom: "20px" }}
        ></img>
      </ListItem>
      <ListItem key={"Data"} disablePadding>
        <ListItemButton
          selected={location.pathname === "/doctors"}
          onClick={() => {
            navigate("/doctors");
          }}
        >
          <ListItemIcon>
            <svg width="35" height="23" viewBox="0 0 45 33" fill="none">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.2806 14.3392V11.9871C21.3868 11.5601 21.5845 11.3393 21.8079 11.2995C22.5843 11.1656 22.4561 14.1764 21.2806 14.3392ZM28.6744 12.7289C30.337 14.4948 32.9078 12.1825 35.4127 11.5347C36.8335 11.1656 37.5989 13.6589 39.4337 12.7506L39.6058 14.7228C40.7447 14.4659 39.9354 17.9434 38.9466 17.7625C38.6207 18.8264 38.4961 19.5755 37.9651 20.2811C36.969 21.5983 35.3541 22.2714 34.0613 22.2424C32.8419 22.2171 31.2891 21.5549 30.293 20.339C29.6815 19.5899 29.4837 18.7685 29.1028 17.6214C28.0482 17.9326 27.3414 14.4044 28.4876 14.7047L28.6744 12.7289ZM35.896 7.22127V7.65551C35.896 7.85816 35.7276 8.021 35.5262 8.021H34.7791V8.75921C34.7791 8.96186 34.6107 9.1247 34.4092 9.1247H33.9698C33.7647 9.1247 33.5999 8.95824 33.5999 8.75921V8.021H32.8528C32.6478 8.021 32.483 7.85454 32.483 7.65551V7.22127C32.483 7.01863 32.6514 6.85579 32.8528 6.85579H33.5999V6.11758C33.5999 5.91493 33.7684 5.75209 33.9698 5.75209H34.4092C34.6143 5.75209 34.7791 5.91855 34.7791 6.11758V6.85579H35.5225C35.7276 6.85217 35.896 7.01863 35.896 7.22127ZM31.5308 4.13092H36.8372C37.0203 4.13092 37.2107 4.15625 37.4012 4.20691C37.8113 4.31185 38.1995 4.52897 38.4852 4.81847C38.8111 5.14777 39.0198 5.56754 39.0198 6.03796C39.0198 6.16462 39.0015 6.30213 38.9649 6.44326L38.4705 8.31411C38.6207 8.47695 38.7671 8.65065 38.899 8.83882C41.825 12.9496 42.7991 20.3498 37.9908 21.3088C38.6316 21.7141 39.4117 21.7865 40.2173 21.7394C42.638 21.8009 44.3262 22.825 45.0037 25.1844V30.3953C45.0001 31.0177 44.6265 31.4447 43.7256 31.5931H35.0538L37.1924 21.4535C36.9214 21.6598 36.6321 21.8371 36.3355 21.9855C35.5774 22.3655 34.7681 22.5536 34.0504 22.5392C33.3729 22.5247 32.6002 22.3256 31.8714 21.9565C31.5381 21.7865 31.2122 21.5838 30.9083 21.345L30.8204 21.3269L32.981 31.5895H30.9266C30.597 27.5872 31.5162 25.463 29.2676 21.62C29.6631 21.5404 29.8865 21.4391 30.2161 21.1894C27.7405 20.5851 26.6932 19.7202 26.6932 16.2209V15.0268C26.847 12.4105 27.5135 10.0945 28.9417 8.40096C29.1541 8.15127 29.4251 7.91606 29.74 7.70256L29.4068 6.44326C29.3702 6.30213 29.3519 6.16462 29.3519 6.03796C29.3519 5.56754 29.5606 5.14777 29.8865 4.81847C30.1722 4.52897 30.5604 4.31185 30.9705 4.20691C31.1573 4.15625 31.3477 4.13092 31.5308 4.13092ZM31.5308 4.86913H36.8372C37.6099 4.86913 38.4339 5.51687 38.2398 6.25508L37.8443 7.74598L37.5806 8.74836C37.3865 9.48657 36.9471 10.1343 36.178 10.1343H32.19C31.421 10.1343 30.9815 9.48657 30.7874 8.74836L30.4065 7.31536L30.1282 6.2587C29.9341 5.52049 30.7581 4.86913 31.5308 4.86913ZM38.2581 27.2905H41.0706V27.9563H38.2581V27.2905ZM33.6951 31.5895L32.2632 25.9588C33.3838 26.194 34.5667 26.2157 35.8228 25.9588L34.4568 31.5895H33.6951ZM33.4571 17.9832C33.3912 17.9217 33.3875 17.8132 33.4461 17.7444C33.5084 17.6756 33.6109 17.672 33.6768 17.7335C33.794 17.8457 33.9075 17.9 34.0137 17.8964C34.1236 17.8964 34.2371 17.8385 34.358 17.7299C34.4275 17.6684 34.5301 17.6756 34.5887 17.748C34.6473 17.8204 34.6399 17.9253 34.5704 17.9869C34.3909 18.1497 34.2078 18.2329 34.0137 18.2365C33.827 18.2402 33.6365 18.1569 33.4571 17.9832ZM37.7344 14.7156C37.804 14.7771 37.815 14.882 37.7564 14.9544C37.6978 15.0268 37.5953 15.0376 37.5257 14.9761C37.2144 14.7083 36.5992 14.8241 36.0682 14.9218C35.7898 14.9725 35.5372 15.0231 35.3321 15.0159C35.2405 15.0123 35.171 14.9327 35.1746 14.8386C35.1783 14.7445 35.2552 14.6721 35.3431 14.6758C35.5115 14.683 35.7496 14.636 36.0096 14.5889C36.6102 14.4767 37.3096 14.3465 37.7344 14.7156ZM32.0545 16.192C32.0691 16.2354 32.0801 16.2861 32.0801 16.3367C32.0801 16.5647 31.9007 16.7529 31.681 16.7529C31.4612 16.7529 31.2818 16.5683 31.2818 16.3367C31.2818 16.2535 31.3038 16.1775 31.344 16.1124C31.1243 16.1268 30.9009 16.1775 30.6812 16.268C30.6043 16.3005 30.5201 16.2499 30.4944 16.1594C30.4688 16.0689 30.5091 15.9676 30.586 15.9387C30.8826 15.8156 31.1829 15.7614 31.4832 15.765C31.7835 15.7686 32.0801 15.8265 32.3731 15.9387C32.45 15.9676 32.494 16.0653 32.4683 16.1594C32.4427 16.2499 32.3621 16.3042 32.2852 16.2752C32.2083 16.239 32.1314 16.2137 32.0545 16.192ZM35.9986 16.1558C35.9839 16.1992 35.9766 16.2426 35.9766 16.2897C35.9766 16.5177 36.1561 16.7058 36.3758 16.7058C36.5955 16.7058 36.775 16.5213 36.775 16.2897C36.775 16.2173 36.7566 16.1486 36.7237 16.0907C36.9398 16.1051 37.1595 16.1486 37.3829 16.2246C37.4598 16.2499 37.544 16.1956 37.566 16.1051C37.5879 16.0111 37.544 15.917 37.4634 15.888C37.1631 15.7867 36.8665 15.736 36.5699 15.736C36.2733 15.736 35.9803 15.7867 35.6873 15.888C35.6104 15.9133 35.5665 16.0111 35.5884 16.1051C35.6104 16.1992 35.691 16.2499 35.7715 16.2246C35.8448 16.1992 35.9217 16.1739 35.9986 16.1558ZM30.5274 15.0195C30.4578 15.081 30.3553 15.0702 30.2967 14.9978C30.2381 14.9254 30.2491 14.8169 30.3187 14.759C30.7471 14.3899 31.4429 14.5202 32.0398 14.6323C32.2999 14.6794 32.5379 14.7264 32.7064 14.7192C32.7979 14.7156 32.8711 14.7879 32.8748 14.882C32.8785 14.9761 32.8089 15.0557 32.7173 15.0593C32.5159 15.0666 32.2596 15.0195 31.9849 14.9653C31.4576 14.8675 30.8423 14.7517 30.5274 15.0195ZM32.6038 19.3837C32.5342 19.3258 32.5233 19.2172 32.5782 19.1448C32.6331 19.0725 32.7393 19.0616 32.8089 19.1195C33.2557 19.4922 33.6768 19.6768 34.0723 19.6768C34.4605 19.6768 34.8304 19.4922 35.1856 19.1304C35.2515 19.0652 35.3541 19.0652 35.4163 19.134C35.4786 19.2027 35.4786 19.3077 35.4127 19.3728C34.9952 19.7962 34.5484 20.0133 34.0723 20.0133C33.5999 20.0169 33.1129 19.807 32.6038 19.3837ZM6.99102 27.7826C7.50006 27.7826 7.91387 28.1915 7.91387 28.6945C7.91387 29.1975 7.50006 29.6064 6.99102 29.6064C6.48199 29.6064 6.06817 29.1975 6.06817 28.6945C6.06817 28.1915 6.48199 27.7826 6.99102 27.7826ZM10.6714 10.8291C10.5726 10.8653 10.4627 10.8074 10.4297 10.7024C10.3968 10.5939 10.4481 10.4781 10.5469 10.4419C10.9315 10.3008 11.316 10.2356 11.7005 10.2356C12.085 10.2393 12.4659 10.308 12.8504 10.4383C12.9493 10.4708 13.0042 10.5866 12.9749 10.6952C12.9419 10.8038 12.8357 10.8617 12.7369 10.8291C12.6087 10.7857 12.4842 10.7495 12.356 10.7205C12.367 10.764 12.3743 10.8074 12.3743 10.8544C12.3743 11.1331 12.1363 11.3574 11.8433 11.3574C11.5503 11.3574 11.3123 11.1331 11.3123 10.8544C11.3123 10.7857 11.327 10.7205 11.3526 10.6626C11.1255 10.688 10.8985 10.7422 10.6714 10.8291ZM16.8567 10.6771C16.8348 10.7314 16.8165 10.6844 16.8165 10.858C16.8165 11.0281 17.0545 11.361 17.3475 11.361C17.6404 11.361 17.8785 11.1367 17.8785 10.858C17.8785 10.7784 17.8602 10.7024 17.8235 10.6337C18.0543 10.659 18.2923 10.7061 18.5267 10.7784C18.6292 10.811 18.7317 10.7459 18.761 10.6373C18.7903 10.5287 18.7317 10.4166 18.6292 10.384C18.2447 10.2646 17.8602 10.2067 17.4793 10.2067C17.0984 10.2067 16.7176 10.2682 16.3404 10.384C16.2415 10.4166 16.1829 10.5287 16.2122 10.6373C16.2415 10.7459 16.3477 10.8074 16.4466 10.7748C16.5857 10.735 16.7249 10.7024 16.8567 10.6771ZM14.5972 31.2855L10.3126 18.783L11.6089 19.9844C11.6163 19.9916 11.6273 20.0025 11.6382 20.0097C11.8287 20.1581 12.0264 20.2739 12.2315 20.3643C12.4329 20.4548 12.6453 20.5199 12.865 20.567C13.2459 20.6502 14.0845 20.7045 14.8792 20.7045C15.5897 20.7045 16.2818 20.6611 16.6187 20.5597C16.8458 20.491 17.0655 20.3933 17.2742 20.2666C17.4793 20.14 17.6771 19.9844 17.8675 19.7998L18.8489 18.8988L14.5972 31.2855ZM10.199 18.6816C9.18096 19.8143 7.88458 20.0929 6.46734 20.0061C6.06817 20.0169 5.67999 20.0495 5.31011 20.1038C4.90362 21.3812 4.79742 22.5536 4.95489 23.6284C5.10504 24.6742 5.50787 25.6295 6.11944 26.5016C6.38677 26.3967 6.67974 26.3388 6.98736 26.3388C8.30572 26.3388 9.37139 27.3954 9.37139 28.6945C9.37139 29.9973 8.30206 31.0503 6.98736 31.0503C5.669 31.0503 4.60333 29.9936 4.60333 28.6945C4.60333 27.9997 4.90728 27.3773 5.39068 26.9467C4.71685 25.9805 4.27374 24.913 4.10528 23.7478C3.95147 22.6803 4.02471 21.5295 4.35796 20.3028C-1.35493 21.8914 0.190485 27.7862 0.190485 32.5882H29.004C29.004 27.8297 30.5164 21.8046 24.7449 20.2775C24.8035 20.5453 24.8365 20.8348 24.8401 21.1242C24.8475 21.5078 24.8072 21.8986 24.7193 22.2714C24.8548 22.3184 24.983 22.3691 25.1111 22.4234C25.3711 22.5392 25.6092 22.673 25.8179 22.8359C26.5064 23.3714 26.7957 24.012 26.8763 24.7104C26.9495 25.3581 26.836 26.0348 26.7078 26.7151L26.7042 26.726C26.6932 26.7875 26.6675 26.9286 26.6419 27.0697C26.4771 28.0215 26.2903 29.0853 25.5616 29.8055C25.3016 30.0624 25.0049 30.2433 24.668 30.341C24.6241 30.3519 24.5838 30.3627 24.5399 30.3736C24.3751 30.6559 24.0674 30.844 23.7122 30.844C23.1849 30.844 22.7564 30.4206 22.7564 29.8996C22.7564 29.3785 23.1849 28.9551 23.7122 28.9551C24.0857 28.9551 24.408 29.1686 24.5655 29.4762C24.7046 29.4146 24.8328 29.3242 24.95 29.2084C25.4847 28.6764 25.6458 27.7501 25.7923 26.925C25.8069 26.8345 25.8253 26.7477 25.8545 26.5704L25.8582 26.5559C25.9754 25.9407 26.0816 25.3328 26.0193 24.7972C25.9644 24.3123 25.763 23.8672 25.2833 23.4945C25.1294 23.3751 24.9537 23.2774 24.7559 23.1905C24.5508 23.1 24.3201 23.0241 24.0711 22.9517C24.0638 22.9481 24.0565 22.9481 24.0491 22.9444C24.0052 22.93 23.9686 22.9083 23.9319 22.8829C23.888 22.8865 23.844 22.8865 23.8001 22.8793C23.4925 22.8214 23.1812 22.7997 22.8956 22.8106C22.6136 22.8214 22.3572 22.8648 22.1522 22.9372C21.0425 23.3316 20.8045 24.4317 20.5701 25.5065L20.5665 25.5209C20.5482 25.6006 20.5298 25.6874 20.4932 25.843C20.4456 26.0457 20.398 26.223 20.3541 26.3967C20.1893 27.0191 20.0428 27.5619 20.2479 28.2132C20.2991 28.3797 20.3577 28.5281 20.42 28.6511C20.5958 28.4629 20.8448 28.3471 21.1231 28.3471C21.6504 28.3471 22.0789 28.7705 22.0789 29.2916C22.0789 29.8127 21.6504 30.2361 21.1231 30.2361C20.7715 30.2361 20.4639 30.0479 20.2991 29.7693C20.1966 29.7078 20.0977 29.6318 20.0098 29.5377C19.7608 29.2844 19.5704 28.9189 19.4312 28.4629C19.1565 27.58 19.3287 26.9286 19.5301 26.1832C19.5777 26.0095 19.6253 25.8322 19.6619 25.6621C19.6729 25.6078 19.7022 25.4811 19.7315 25.3436C19.7315 25.3364 19.7352 25.3328 19.7352 25.3255C20.0208 24.0264 20.3101 22.6948 21.8665 22.1411C22.1522 22.0398 22.4964 21.9783 22.8663 21.9638C23.1959 21.9493 23.5474 21.971 23.8917 22.0325C23.9576 21.743 23.9869 21.4355 23.9795 21.1315C23.9722 20.7515 23.9136 20.386 23.7964 20.0857C23.4522 20.0386 23.0933 20.0097 22.7198 19.9988C21.3245 20.0821 20.0428 19.8143 19.032 18.7214L19.1273 18.631C19.2591 18.5079 19.4019 18.3849 19.5337 18.2655C20.6141 17.3029 21.3099 16.6841 21.2293 14.8712C21.2293 14.8675 21.2293 14.8603 21.2293 14.8567V14.7409C21.2623 14.7445 21.2989 14.7445 21.3355 14.7373C22.1522 14.6251 22.5916 13.677 22.6978 12.7723C22.7271 12.5226 22.7308 12.2766 22.7125 12.0558C22.6941 11.817 22.6465 11.5999 22.5696 11.4226C22.4195 11.0643 22.1705 10.8544 21.8152 10.8798L22.2584 10.6192C22.3096 9.94252 22.4781 9.02338 22.6099 8.15851C22.6722 7.75684 22.6941 7.37326 22.6832 7.00777C22.9212 5.08625 22.5294 3.73648 21.6028 2.86438C19.845 1.15998 17.4207 0.533949 14.5826 0.584611C12.0301 0.566518 10.1807 1.29025 8.86602 2.58936C7.48907 2.39395 6.64678 3.07788 6.42706 4.7859V6.21528C6.47833 7.10186 6.76763 7.41668 7.12652 7.34793C7.13751 7.49991 7.14849 7.6519 7.17413 7.8075C7.32061 8.78092 7.55499 9.83396 7.64654 10.6916L7.97979 10.8689V11.1837C7.82965 11.0245 7.65386 10.9268 7.45977 10.8942C7.05328 10.8219 6.77496 11.039 6.61016 11.4226C6.53692 11.5999 6.48931 11.8206 6.46734 12.0558C6.44903 12.2766 6.45269 12.5263 6.48199 12.7723C6.58819 13.677 7.02764 14.6251 7.84429 14.7373C7.88824 14.7445 7.93585 14.7445 7.97979 14.7373V15.5117C7.97979 15.5406 7.98345 15.566 7.98712 15.5949C8.29107 16.9736 8.65362 17.2921 9.41534 17.9651C9.55084 18.0846 9.70098 18.2184 9.85113 18.356L10.199 18.6816ZM20.7862 8.97995C16.6187 6.15738 14.0552 3.81971 10.5836 5.90045C9.34942 6.64228 8.9649 8.15851 8.40093 9.00528V15.5225C8.73052 17.0134 9.13336 17.1401 10.1441 18.0737L11.8946 19.6949C12.2095 19.9409 12.5684 20.0857 12.9456 20.1725C13.6121 20.3209 15.846 20.3679 16.4722 20.1762C16.8531 20.0604 17.212 19.8469 17.5416 19.5176L18.8123 18.3487C20.0391 17.2197 20.8741 16.7348 20.7862 14.8675V8.97995ZM12.3377 8.61085C12.5062 8.60361 12.6453 8.72664 12.6526 8.88587C12.66 9.04509 12.5318 9.17898 12.3633 9.18622C11.8982 9.20793 11.5027 9.29478 11.1732 9.44676C10.8509 9.59513 10.5872 9.80501 10.3785 10.0728C10.2796 10.1994 10.0892 10.2284 9.95367 10.1307C9.81817 10.0366 9.79254 9.85567 9.89141 9.72902C10.1587 9.38524 10.4957 9.11746 10.9095 8.92929C11.3123 8.74112 11.7847 8.63256 12.3377 8.61085ZM17.1131 9.1247C16.9446 9.1247 16.8128 8.99443 16.8128 8.83882C16.8128 8.6796 16.9483 8.55295 17.1168 8.55295C17.6185 8.55657 18.0762 8.64341 18.4864 8.82797C18.9002 9.01252 19.2664 9.29116 19.574 9.6675C19.6766 9.79416 19.6509 9.97147 19.5191 10.0692C19.3873 10.1669 19.1968 10.1415 19.0943 10.0185C18.8453 9.71454 18.556 9.4938 18.23 9.34906C17.8968 9.19707 17.5232 9.12832 17.1131 9.1247ZM13.9344 14.1764C13.8282 14.0931 13.8172 13.9448 13.9051 13.8471C13.993 13.7494 14.1504 13.7349 14.253 13.8181C14.3775 13.9158 14.4947 13.9665 14.6082 13.9701C14.7217 13.9701 14.8462 13.9231 14.9817 13.8181C15.0879 13.7349 15.2418 13.7494 15.3296 13.8507C15.4175 13.952 15.3992 14.0968 15.2967 14.18C15.0696 14.3573 14.8389 14.4405 14.6045 14.4369C14.3702 14.4333 14.1468 14.3428 13.9344 14.1764ZM13.158 17.2631C13.0298 17.198 12.9822 17.0496 13.0518 16.9302C13.1177 16.8108 13.2752 16.7637 13.4034 16.8289C13.8025 17.0315 14.1981 17.1328 14.5862 17.1328C14.9744 17.1328 15.3626 17.0351 15.7508 16.8289C15.8753 16.7637 16.0328 16.8072 16.1024 16.9266C16.1719 17.046 16.1243 17.1944 15.9998 17.2595C15.5347 17.5019 15.0623 17.6214 14.5862 17.6214C14.1102 17.625 13.6341 17.5019 13.158 17.2631ZM7.91387 14.3392V11.9871C7.80767 11.5601 7.60992 11.3393 7.38653 11.2995C6.61016 11.1656 6.73467 14.1764 7.91387 14.3392ZM14.1761 28.0287L12.4952 21.2835C13.9673 21.6091 15.1209 21.6381 16.7725 21.2835L15.1758 28.0287H14.1761Z"
                fill={location.pathname === "/doctors" ? "#194AF5" : "#B7B7B7"}
              />
            </svg>
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography
                color={location.pathname === "/doctors" && "primary"}
                variant="body2"
              >
                {"Doctors"}
              </Typography>
            }
          />{" "}
        </ListItemButton>
      </ListItem>
      <ListItem key={"RegisteredDoctors"} disablePadding>
        <ListItemButton
          selected={location.pathname === "/registered-doctors"}
          onClick={() => {
            navigate("/registered-doctors");
          }}
        >
          <ListItemIcon>
            <HowToRegIcon
              sx={{
                color:
                  location.pathname === "/registered-doctors"
                    ? "#194AF5"
                    : "#B7B7B7",
              }}
            />
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography
                color={
                  location.pathname === "/registered-doctors" && "primary"
                }
                variant="body2"
              >
                {"Registered Doctors"}
              </Typography>
            }
          />
        </ListItemButton>
      </ListItem>
      <ListItem key={"Patients"} disablePadding>
        <ListItemButton
          selected={location.pathname === "/patients"}
          onClick={() => {
            navigate("/patients");
          }}
        >
          <ListItemIcon>
            <svg width={20} height={28} viewBox="0 0 25 33" fill="none">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.8854 17.8171C19.5417 19.1453 19.9115 20.6401 19.9115 22.2234C19.9115 24.6843 19.0182 26.9395 17.5365 28.6765L15.2865 26.4265C16.2005 25.2703 16.7448 23.8093 16.7448 22.2208C16.7448 18.4708 13.7057 15.4317 9.95573 15.4317C8.36719 15.4317 6.90625 15.976 5.75 16.8901L3.5026 14.6427C4.88802 13.4604 6.60417 12.6531 8.49219 12.3744L8.45833 12.3588L12.9323 7.46558L10.2031 5.78068L7.04427 8.78849C6.29948 9.49683 5.1224 9.46818 4.41406 8.72339C3.70573 7.9786 3.73438 6.80151 4.47917 6.09318L8.67187 2.10099L8.66927 2.09839C9.33594 1.46297 10.3568 1.4187 11.0703 1.95256L16.9635 5.58797C17.0417 5.63745 17.1172 5.68953 17.1875 5.74943L18.8281 6.62183C20.6042 7.56714 20.7526 9.22599 19.4115 10.7234L16.276 14.2234L22.9583 13.8067V13.8041C23.9844 13.739 24.8698 14.5229 24.9349 15.5489C24.9375 15.588 24.9401 15.6296 24.9401 15.6687C24.9401 15.7468 24.9349 15.8223 24.9245 15.9005L24.2266 25.7859C24.1536 26.8119 23.263 27.5828 22.237 27.5125C21.2109 27.4395 20.4375 26.5489 20.5104 25.5229L21.0651 17.6557L18.8854 17.8171ZM20.7031 0.176514C22.4427 0.176514 23.8542 1.58537 23.8542 3.32756C23.8542 5.06714 22.4427 6.4786 20.7031 6.4786C18.9635 6.4786 17.5521 5.06714 17.5521 3.32756C17.5521 1.58537 18.9635 0.176514 20.7031 0.176514ZM15.4401 30.5307C13.8672 31.5697 11.9818 32.1765 9.95573 32.1765C4.45573 32.1765 0 27.7208 0 22.2208C0 20.1947 0.606771 18.3093 1.64583 16.7364L3.95312 19.0437C3.45052 19.9916 3.16406 21.0723 3.16406 22.2208C3.16406 25.9708 6.20312 29.0098 9.95312 29.0098C11.1016 29.0098 12.1823 28.7234 13.1302 28.2208L15.4401 30.5307Z"
                fill={location.pathname === "/patients" ? "#194AF5" : "#B7B7B7"}
              />
            </svg>
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography
                color={location.pathname === "/patients" && "primary"}
                variant="body2"
              >
                {"Patients"}
              </Typography>
            }
          />{" "}
        </ListItemButton>
      </ListItem>
      <ListItem key={"Hospital"} disablePadding>
        <ListItemButton
          selected={location.pathname === "/medicalFaculty"}
          onClick={() => {
            navigate("/medicalFaculty");
          }}
        >
          <ListItemIcon>
            <svg width={35} height={33} viewBox="0 0 45 33" fill="none">
              <g clipPath="url(#clip0_4185_12340)">
                <path
                  d="M20.1712 25.4188H24.4172C24.6197 25.4188 24.7835 25.5826 24.7835 25.7851V32.1422C29.765 32.1422 34.7464 32.1422 39.7309 32.1422V10.9776H30.6582V32.1422H29.8007V1.8573H14.7193V32.1392H13.8617V10.9776H4.85754V32.1422H19.805V25.7851C19.805 25.5826 19.9687 25.4188 20.1712 25.4188ZM21.4158 3.70637H23.1696C23.4972 3.70637 23.7651 3.97435 23.7651 4.30189V6.9162H26.3795C26.707 6.9162 26.975 7.18418 26.975 7.51171V9.2655C26.975 9.59304 26.707 9.86102 26.3795 9.86102H23.7651V12.4753C23.7651 12.8029 23.4972 13.0708 23.1696 13.0708H21.4158C21.0883 13.0708 20.8203 12.8029 20.8203 12.4753V9.86102H18.206C17.8785 9.86102 17.6105 9.59304 17.6105 9.2655V7.51171C17.6105 7.18418 17.8785 6.9162 18.206 6.9162H20.8203V4.30189C20.8203 3.97435 21.0883 3.70637 21.4158 3.70637ZM4.42877 32.9998C4.19056 32.9998 4 32.8062 4 32.571V10.7483C4 10.4 4.28287 10.1201 4.63125 10.1201H13.8617V1.75308C13.8617 1.54763 13.9451 1.36004 14.0821 1.22307C14.0821 1.11886 14.5079 0.999756 14.6151 0.999756H29.9049C30.1133 0.999756 30.3009 1.08313 30.4379 1.2201C30.5778 1.37791 30.6582 1.53572 30.6582 1.75308V10.1171H39.9542C40.2996 10.1171 40.5855 10.4029 40.5855 10.7483V32.571C40.5855 32.8092 40.3919 32.9998 40.1567 32.9998C28.2494 32.9998 16.3391 32.9998 4.42877 32.9998ZM20.5375 32.1422H24.051V26.1513H20.5375V32.1422ZM32.9271 22.1405H37.6615C37.7002 22.1405 37.733 22.1644 37.733 22.1912V23.5906C37.733 23.6174 37.7002 23.6442 37.6615 23.6442H32.9271C32.8884 23.6442 32.8557 23.6204 32.8557 23.5906V22.1912C32.8557 22.1644 32.8884 22.1405 32.9271 22.1405ZM6.89123 22.1405H11.6256C11.6643 22.1405 11.697 22.1644 11.697 22.1912V23.5906C11.697 23.6174 11.6643 23.6442 11.6256 23.6442H6.89123C6.85252 23.6442 6.81976 23.6204 6.81976 23.5906V22.1912C6.81976 22.1644 6.85252 22.1405 6.89123 22.1405ZM32.9271 19.0826H37.6615C37.7002 19.0826 37.733 19.1064 37.733 19.1362V20.5356C37.733 20.5654 37.7002 20.5862 37.6615 20.5862H32.9271C32.8884 20.5862 32.8557 20.5624 32.8557 20.5356V19.1362C32.8557 19.1034 32.8884 19.0826 32.9271 19.0826ZM32.9271 16.0216H37.6615C37.7002 16.0216 37.733 16.0454 37.733 16.0752V17.4747C37.733 17.5015 37.7002 17.5253 37.6615 17.5253H32.9271C32.8884 17.5253 32.8557 17.5015 32.8557 17.4747V16.0752C32.8557 16.0454 32.8884 16.0216 32.9271 16.0216ZM6.89123 19.0826H11.6256C11.6643 19.0826 11.697 19.1064 11.697 19.1362V20.5356C11.697 20.5654 11.6643 20.5862 11.6256 20.5862H6.89123C6.85252 20.5862 6.81976 20.5624 6.81976 20.5356V19.1362C6.81976 19.1034 6.85252 19.0826 6.89123 19.0826ZM6.89123 16.0216H11.6256C11.6643 16.0216 11.697 16.0454 11.697 16.0752V17.4747C11.697 17.5015 11.6643 17.5253 11.6256 17.5253H6.89123C6.85252 17.5253 6.81976 17.5015 6.81976 17.4747V16.0752C6.81976 16.0454 6.85252 16.0216 6.89123 16.0216ZM25.3403 20.7381H27.8682C27.907 20.7381 27.9397 20.7709 27.9397 20.8096V23.3375C27.9397 23.3762 27.907 23.409 27.8682 23.409H25.3403C25.3016 23.409 25.2688 23.3762 25.2688 23.3375V20.8096C25.2688 20.7679 25.3016 20.7381 25.3403 20.7381ZM20.996 20.7381H23.524C23.5627 20.7381 23.5954 20.7709 23.5954 20.8096V23.3375C23.5954 23.3762 23.5627 23.409 23.524 23.409H20.996C20.9573 23.409 20.9245 23.3762 20.9245 23.3375V20.8096C20.9245 20.7679 20.9573 20.7381 20.996 20.7381ZM16.6517 20.7381H19.1797C19.2214 20.7381 19.2511 20.7709 19.2511 20.8096V23.3375C19.2511 23.3762 19.2184 23.409 19.1797 23.409H16.6517C16.613 23.409 16.5803 23.3762 16.5803 23.3375V20.8096C16.5803 20.7679 16.613 20.7381 16.6517 20.7381ZM25.3403 15.8311H27.8682C27.907 15.8311 27.9397 15.8638 27.9397 15.9025V18.4305C27.9397 18.4692 27.907 18.5019 27.8682 18.5019H25.3403C25.3016 18.5019 25.2688 18.4692 25.2688 18.4305V15.9025C25.2688 15.8638 25.3016 15.8311 25.3403 15.8311ZM20.996 15.8311H23.524C23.5627 15.8311 23.5954 15.8638 23.5954 15.9025V18.4305C23.5954 18.4692 23.5627 18.5019 23.524 18.5019H20.996C20.9573 18.5019 20.9245 18.4692 20.9245 18.4305V15.9025C20.9245 15.8638 20.9573 15.8311 20.996 15.8311ZM16.6517 15.8311H19.1797C19.2214 15.8311 19.2511 15.8638 19.2511 15.9025V18.4305C19.2511 18.4692 19.2184 18.5019 19.1797 18.5019H16.6517C16.613 18.5019 16.5803 18.4692 16.5803 18.4305V15.9025C16.5803 15.8638 16.613 15.8311 16.6517 15.8311Z"
                  fill={
                    location.pathname === "/medicalFaculty"
                      ? "#194AF5"
                      : "#B7B7B7"
                  }
                />
              </g>
              <defs>
                <clipPath id="clip0_4185_12340">
                  <rect
                    width={45}
                    height={32}
                    fill="white"
                    transform="translate(0 0.588135)"
                  />
                </clipPath>
              </defs>
            </svg>
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography
                color={location.pathname === "/medicalFaculty" && "primary"}
                variant="body2"
              >
                {"Hospital"}
              </Typography>
            }
          />
        </ListItemButton>
      </ListItem>

      <ListItem key={"Drugs"} disablePadding>
        <ListItemButton
          selected={location.pathname === "/drugs"}
          onClick={() => {
            navigate("/drugs");
          }}
        >
          <ListItemIcon>
            <svg width={26} height={26} viewBox="0 0 32 33" fill="none">
              <g clipPath="url(#clip0_4214_13547)">
                <path
                  d="M16 16.5881C22.0751 16.5881 27 13.9018 27 10.5881C27 7.27443 22.0751 4.58813 16 4.58813C9.92487 4.58813 5 7.27443 5 10.5881C5 13.9018 9.92487 16.5881 16 16.5881Z"
                  stroke={
                    location.pathname === "/drugs" ? "#194AF5" : "#B7B7B7"
                  }
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M5 10.5881V16.5881C5 19.9019 9.925 22.5881 16 22.5881C22.075 22.5881 27 19.9019 27 16.5881V10.5881"
                  stroke={
                    location.pathname === "/drugs" ? "#194AF5" : "#B7B7B7"
                  }
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M5 16.5881V22.5881C5 25.9019 9.925 28.5881 16 28.5881C22.075 28.5881 27 25.9019 27 22.5881V16.5881"
                  stroke={
                    location.pathname === "/drugs" ? "#194AF5" : "#B7B7B7"
                  }
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_4214_13547">
                  <rect
                    width={32}
                    height={32}
                    fill="white"
                    transform="translate(0 0.588135)"
                  />
                </clipPath>
              </defs>
            </svg>
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography
                color={location.pathname === "/drugs" && "primary"}
                variant="body2"
              >
                {"Database"}
              </Typography>
            }
          />
        </ListItemButton>
      </ListItem>
      <ListItem key={"PatientHistoryMaster"} disablePadding>
        <ListItemButton
          sx={{ pl: 4 }}
          selected={location.pathname === "/patient-history-master"}
          onClick={() => navigate("/patient-history-master")}
        >
          <ListItemIcon>
            <AssignmentIndOutlinedIcon
              sx={{
                fontSize: 24,
                color:
                  location.pathname === "/patient-history-master"
                    ? "#194AF5"
                    : "#B7B7B7",
              }}
            />
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography
                color={
                  location.pathname === "/patient-history-master" && "primary"
                }
                variant="body2"
              >
                {"Patient History Master"}
              </Typography>
            }
          />
        </ListItemButton>
      </ListItem>
      <ListItem key={"CGHS"} disablePadding>
        <ListItemButton
          selected={location.pathname === "/cghs-rates"}
          onClick={() => {
            navigate("/cghs-rates");
          }}
        >
          <ListItemIcon>
            <svg width={26} height={26} viewBox="0 0 32 32" fill="none">
              <path
                d="M16 2C8.268 2 2 8.268 2 16C2 23.732 8.268 30 16 30C23.732 30 30 23.732 30 16C30 8.268 23.732 2 16 2Z"
                stroke={location.pathname === "/cghs-rates" ? "#194AF5" : "#B7B7B7"}
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M16 8V16L21 19"
                stroke={location.pathname === "/cghs-rates" ? "#194AF5" : "#B7B7B7"}
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M10 13H8M10 19H8M24 13H22M24 19H22"
                stroke={location.pathname === "/cghs-rates" ? "#194AF5" : "#B7B7B7"}
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography
                color={location.pathname === "/cghs-rates" && "primary"}
                variant="body2"
              >
                {"CGHS Rates"}
              </Typography>
            }
          />
        </ListItemButton>
      </ListItem>
      <ListItem key={"DentalMaster"} disablePadding>
        <ListItemButton
          selected={location.pathname === "/dental-master"}
          onClick={() => {
            navigate("/dental-master");
          }}
        >
          <ListItemIcon>
            <svg width={26} height={26} viewBox="0 0 24 24" fill="none">
              <path
                d="M8.5 3C6 3 4 5 4 8c0 3 1 5 1.5 8 .4 2.4.8 4 1.8 4 1.2 0 1.4-2 1.7-4 .2-1.4.6-2 1-2s.8.6 1 2c.3 2 .5 4 1.7 4 1 0 1.4-1.6 1.8-4 .5-3 1.5-5 1.5-8 0-3-2-5-4.5-5-1 0-1.7.4-2.5.4S9.5 3 8.5 3Z"
                stroke={
                  location.pathname === "/dental-master" ? "#194AF5" : "#B7B7B7"
                }
                strokeWidth={1.6}
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography
                color={location.pathname === "/dental-master" && "primary"}
                variant="body2"
              >
                {"Dental Master"}
              </Typography>
            }
          />
        </ListItemButton>
      </ListItem>
      <ListItem key={"ImmunizationMaster"} disablePadding>
        <ListItemButton
          selected={location.pathname === "/immunization-master"}
          onClick={() => {
            navigate("/immunization-master");
          }}
        >
          <ListItemIcon>
            <svg width={26} height={26} viewBox="0 0 24 24" fill="none">
              <path
                d="m18 2 4 4M17 7l3-3M11.5 8.5 15.5 12.5M8 12l4 4M3.5 21 2 22M9.5 6.5l8 8-4.5 4.5a2 2 0 0 1-2.8 0l-5.2-5.2a2 2 0 0 1 0-2.8L9.5 6.5Z"
                stroke={
                  location.pathname === "/immunization-master"
                    ? "#194AF5"
                    : "#B7B7B7"
                }
                strokeWidth={1.6}
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography
                color={
                  location.pathname === "/immunization-master" && "primary"
                }
                variant="body2"
              >
                {"Immunization Master"}
              </Typography>
            }
          />
        </ListItemButton>
      </ListItem>
      <ListItem key={"Consent"} disablePadding>
        <ListItemButton
          selected={location.pathname.startsWith("/consent")}
          onClick={() => {
            navigate("/consent");
          }}
        >
          <ListItemIcon>
            <AssignmentTurnedInOutlinedIcon
              sx={{
                fontSize: 24,
                color: location.pathname.startsWith("/consent")
                  ? "#194AF5"
                  : "#B7B7B7",
              }}
            />
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography
                color={location.pathname.startsWith("/consent") && "primary"}
                variant="body2"
              >
                {"Consent"}
              </Typography>
            }
          />
        </ListItemButton>
      </ListItem>
      <ListItem key={"PMJAY"} disablePadding>
        <ListItemButton
          selected={location.pathname === "/pmjay"}
          onClick={() => navigate("/pmjay")}
        >
          <ListItemIcon>
            <svg width={26} height={26} viewBox="0 0 32 32" fill="none">
              <path
                d="M16 2C8.268 2 2 8.268 2 16C2 23.732 8.268 30 16 30C23.732 30 30 23.732 30 16C30 8.268 23.732 2 16 2Z"
                stroke={location.pathname === "/pmjay" ? "#194AF5" : "#B7B7B7"}
                strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"
              />
              <path
                d="M10 16H22M16 10V22"
                stroke={location.pathname === "/pmjay" ? "#194AF5" : "#B7B7B7"}
                strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"
              />
              <path
                d="M10 10L22 22M22 10L10 22"
                stroke={location.pathname === "/pmjay" ? "#194AF5" : "#B7B7B7"}
                strokeWidth={1.2} strokeLinecap="round"
              />
            </svg>
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography
                color={location.pathname === "/pmjay" && "primary"}
                variant="body2"
              >
                {"PMJAY Master"}
              </Typography>
            }
          />
        </ListItemButton>
      </ListItem>
      <ListItem key={"ReportTemplate"} disablePadding>
        <ListItemButton
          selected={location.pathname === "/report-template"}
          onClick={() => navigate("/report-template")}
        >
          <ListItemIcon>
            <svg width={26} height={26} viewBox="0 0 32 32" fill="none">
              <path
                d="M9 3H19L25 9V27C25 27.5523 24.5523 28 24 28H9C8.44772 28 8 27.5523 8 27V4C8 3.44772 8.44772 3 9 3Z"
                stroke={
                  location.pathname === "/report-template"
                    ? "#194AF5"
                    : "#B7B7B7"
                }
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12 14H21M12 18H21M12 22H17"
                stroke={
                  location.pathname === "/report-template"
                    ? "#194AF5"
                    : "#B7B7B7"
                }
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography
                color={location.pathname === "/report-template" && "primary"}
                variant="body2"
              >
                {"Report Templates"}
              </Typography>
            }
          />
        </ListItemButton>
      </ListItem>

      <ListItem key={"LabMethodMaster"} disablePadding>
        <ListItemButton
          selected={location.pathname === "/lab-method-master"}
          onClick={() => navigate("/lab-method-master")}
        >
          <ListItemIcon>
            <BiotechOutlinedIcon
              sx={{
                fontSize: 26,
                color:
                  location.pathname === "/lab-method-master"
                    ? "#194AF5"
                    : "#B7B7B7",
              }}
            />
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography
                color={location.pathname === "/lab-method-master" && "primary"}
                variant="body2"
              >
                {"Method Master"}
              </Typography>
            }
          />
        </ListItemButton>
      </ListItem>

      <ListItem key={"LabCalculationMaster"} disablePadding>
        <ListItemButton
          selected={location.pathname === "/lab-calculation-master"}
          onClick={() => navigate("/lab-calculation-master")}
        >
          <ListItemIcon>
            <FunctionsIcon
              sx={{
                fontSize: 26,
                color:
                  location.pathname === "/lab-calculation-master"
                    ? "#194AF5"
                    : "#B7B7B7",
              }}
            />
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography
                color={
                  location.pathname === "/lab-calculation-master" && "primary"
                }
                variant="body2"
              >
                {"Calculation Master"}
              </Typography>
            }
          />
        </ListItemButton>
      </ListItem>

      <ListItem key={"ExternalLabs"} disablePadding>
        <ListItemButton
          selected={location.pathname === "/external-labs"}
          onClick={() => navigate("/external-labs")}
        >
          <ListItemIcon>
            <ScienceOutlinedIcon
              sx={{
                fontSize: 26,
                color:
                  location.pathname === "/external-labs"
                    ? "#194AF5"
                    : "#B7B7B7",
              }}
            />
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography
                color={location.pathname === "/external-labs" && "primary"}
                variant="body2"
              >
                {"External Labs"}
              </Typography>
            }
          />
        </ListItemButton>
      </ListItem>

      <ListItem key={"E-Clinic"} disablePadding>
  <ListItemButton
    selected={location.pathname.includes("/eclinic")}
    onClick={() => navigate("/eclinic")}
  >
    <ListItemIcon>
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
        <path
          d="M12 5V19"
          stroke={
            location.pathname.includes("/eclinic")
              ? "#194AF5"
              : "#B7B7B7"
          }
          strokeWidth="2"
          strokeLinecap="round"
        />

        <path
          d="M5 12H19"
          stroke={
            location.pathname.includes("/eclinic")
              ? "#194AF5"
              : "#B7B7B7"
          }
          strokeWidth="2"
          strokeLinecap="round"
        />

        <circle
          cx="12"
          cy="12"
          r="9"
          stroke={
            location.pathname.includes("/eclinic")
              ? "#194AF5"
              : "#B7B7B7"
          }
          strokeWidth="2"
        />
      </svg>
    </ListItemIcon>

    <ListItemText
      primary={
        <Typography
          color={location.pathname.includes("/eclinic") && "primary"}
          variant="body2"
        >
          {"E-Clinic"}
        </Typography>
      }
    />
  </ListItemButton>
</ListItem>

      <ListItem key={"AbdmBridge"} disablePadding>
        <ListItemButton
          selected={location.pathname === "/abdm-bridge"}
          onClick={() => navigate("/abdm-bridge")}
        >
          <ListItemIcon>
            <HubOutlinedIcon
              sx={{
                fontSize: 26,
                color:
                  location.pathname === "/abdm-bridge" ? "#194AF5" : "#B7B7B7",
              }}
            />
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography
                color={location.pathname === "/abdm-bridge" && "primary"}
                variant="body2"
              >
                {"ABDM Bridge"}
              </Typography>
            }
          />
        </ListItemButton>
      </ListItem>
      {/* <ListItem key={"Doctor Request"} disablePadding>
        <ListItemButton
          selected={location.pathname === "/request"}
          onClick={() => {
            navigate("/request");
          }}
        >
          <ListItemIcon>
            <svg width={35} height={26} viewBox="0 0 45 33" fill="none">
              <g clipPath="url(#clip0_4185_12346)">
                <path
                  d="M23.9012 14.2503C23.9563 14.2502 24.0101 14.2663 24.056 14.2967C24.1018 14.327 24.1376 14.3703 24.1588 14.4209C24.1799 14.4715 24.1855 14.5272 24.1749 14.5809C24.1642 14.6347 24.1378 14.6841 24.0989 14.7229C24.06 14.7618 24.0104 14.7882 23.9564 14.7989C23.9024 14.8097 23.8464 14.8042 23.7955 14.7833C23.7446 14.7623 23.7011 14.7268 23.6705 14.6813C23.6399 14.6357 23.6236 14.5821 23.6236 14.5273C23.6235 14.491 23.6306 14.455 23.6445 14.4214C23.6584 14.3878 23.6789 14.3572 23.7047 14.3315C23.7304 14.3058 23.7611 14.2854 23.7948 14.2714C23.8285 14.2575 23.8647 14.2503 23.9012 14.2503ZM24.1468 10.1452C24.2069 10.1601 24.2599 10.1956 24.2965 10.2454C24.37 10.3396 24.3904 10.4919 24.37 10.6518C24.3514 10.801 24.3 10.9443 24.2196 11.0716C24.1305 11.207 24.0155 11.2944 23.8794 11.2856C23.8699 11.7265 23.6529 11.9289 23.3698 12.1937L23.2616 12.296L23.2249 12.3305L23.2337 12.3366C23.1996 12.3638 23.1637 12.3886 23.1262 12.4111C23.0306 12.482 22.9249 12.5384 22.8126 12.5784C22.6629 12.6298 22.5055 12.6554 22.3472 12.6542C22.1829 12.6567 22.0193 12.6315 21.8634 12.5797L21.7954 12.5553C21.7061 12.5287 21.6206 12.491 21.5409 12.4429L21.5069 12.4219C21.4691 12.5355 21.4175 12.6439 21.3531 12.7449L22.4091 13.477L23.4011 12.6542C23.3394 12.558 23.2885 12.4554 23.2494 12.3481C23.6869 12.6576 23.7815 13.3036 23.7671 13.8251C23.7671 13.8928 23.7631 13.9104 23.7617 13.9327C23.6557 13.9563 23.5579 14.0077 23.4787 14.0817C23.3995 14.1556 23.3417 14.2495 23.3114 14.3533C23.2811 14.4571 23.2793 14.5671 23.3064 14.6718C23.3334 14.7766 23.3882 14.8721 23.4651 14.9485C23.5664 15.0582 23.7065 15.1243 23.8559 15.1332C24.0052 15.142 24.1522 15.0928 24.2659 14.9959C24.3383 14.9397 24.3968 14.8677 24.4371 14.7856C24.4774 14.7035 24.4984 14.6133 24.4986 14.5219C24.4986 14.4267 24.4732 14.3333 24.4251 14.251C24.323 14.075 24.2121 14.0235 24.0427 13.9395C24.0312 13.9334 24.0427 13.9077 24.0427 13.8359C24.0577 13.5149 24.0242 13.1935 23.9434 12.8824C24.0175 12.9209 24.0949 12.9529 24.1747 12.9779C24.7802 13.1201 25.5246 13.1811 25.7913 13.33C25.9235 13.4018 26.0394 13.5 26.1315 13.6185C26.3676 13.9287 26.3873 14.8212 26.4717 15.2005C26.4506 15.4226 26.3247 15.5499 26.0757 15.5689H18.5425C18.2941 15.5458 18.1676 15.4178 18.1465 15.1964C18.2322 14.8172 18.2526 13.9239 18.4867 13.6145C18.5792 13.495 18.6963 13.3966 18.8303 13.326C19.2092 13.1161 20.138 13.0592 20.7558 12.8885C20.6976 13.064 20.6615 13.246 20.6483 13.4303C20.5802 13.4824 20.4006 13.5434 20.3441 13.6104C20.2458 13.7274 20.1579 13.8527 20.0815 13.9849C20.0695 14.0055 20.0632 14.0288 20.0631 14.0526C20.0631 14.0716 20.0829 14.0912 20.0747 14.1075L20.0618 14.1325C19.8849 14.4711 19.7699 14.851 19.8243 15.0129C19.839 15.0514 19.8631 15.0857 19.8945 15.1125C19.9258 15.1394 19.9635 15.158 20.0039 15.1666C20.0739 15.1849 20.1459 15.1943 20.2183 15.1944C20.2394 15.1944 20.2611 15.1944 20.2822 15.1944C20.293 15.2044 20.3049 15.2132 20.3176 15.2208C20.3321 15.2293 20.3474 15.2366 20.3632 15.2425C20.3829 15.25 20.4039 15.2539 20.4251 15.254C20.4477 15.254 20.4701 15.2495 20.4909 15.2408C20.5118 15.2322 20.5307 15.2195 20.5466 15.2035C20.5625 15.1875 20.575 15.1685 20.5835 15.1476C20.5919 15.1268 20.5961 15.1044 20.5959 15.082C20.5953 15.0585 20.59 15.0355 20.5802 15.0142C20.5671 14.9821 20.5447 14.9546 20.5159 14.9352C20.4871 14.9158 20.4531 14.9053 20.4183 14.9052C20.3557 14.9052 20.2666 14.9363 20.2666 14.9987V15.0027H20.223C20.1696 15.0032 20.1163 14.9968 20.0645 14.9837C20.0339 14.9756 20.0162 14.9641 20.0121 14.9513C19.9726 14.8375 20.0801 14.5226 20.236 14.2179L20.2557 14.1806C20.2845 14.1691 20.3085 14.148 20.3237 14.121C20.3911 14.0034 20.4687 13.8919 20.5557 13.7878C20.6203 13.7289 20.6999 13.6887 20.7857 13.6714H20.8C20.8428 13.702 20.882 13.7372 20.917 13.7763C21.0099 13.8807 21.0919 13.9941 21.162 14.1149C21.1776 14.1427 21.2157 14.1488 21.23 14.1752C21.4103 14.465 21.5117 14.7975 21.4872 14.9242C21.4817 14.954 21.4572 14.9716 21.4191 14.9837C21.361 14.9996 21.3011 15.008 21.2409 15.0088C21.2389 15.0044 21.2366 15.0001 21.2341 14.9959C21.2341 14.9336 21.1443 14.9045 21.0817 14.9025C21.0469 14.9026 21.0129 14.9131 20.9841 14.9325C20.9552 14.9519 20.9328 14.9794 20.9197 15.0115C20.9102 15.0329 20.9049 15.0559 20.9041 15.0793C20.9041 15.1243 20.9221 15.1676 20.9541 15.1994C20.9861 15.2313 21.0296 15.2492 21.0749 15.2492C21.0963 15.2491 21.1175 15.2452 21.1375 15.2377C21.1531 15.2319 21.1681 15.2246 21.1824 15.216C21.1909 15.2109 21.1991 15.2053 21.2069 15.1991H21.2314C21.3155 15.2009 21.3995 15.1899 21.4804 15.1666C21.5297 15.1547 21.5746 15.1289 21.6096 15.0923C21.6446 15.0556 21.6683 15.0097 21.6777 14.96C21.7076 14.7948 21.5872 14.4305 21.4096 14.1C21.417 14.0827 21.4207 14.064 21.4205 14.0452C21.4198 14.0214 21.4133 13.9981 21.4015 13.9774C21.3213 13.84 21.2279 13.7107 21.1225 13.5914C21.066 13.5285 20.9415 13.5102 20.9286 13.4262C20.8946 13.2075 20.9898 12.9366 21.1327 12.7009C21.1701 12.6545 21.2033 12.6048 21.232 12.5526L21.2538 12.5228C21.3185 12.4578 21.3981 12.4095 21.4858 12.382C21.4527 12.3571 21.4194 12.3301 21.3858 12.3007L21.281 12.2073L21.2742 12.2012C21.0021 11.9655 20.77 11.7657 20.7299 11.2829C20.5408 11.2666 20.4067 11.0879 20.3407 10.8766C20.3061 10.7639 20.2911 10.6462 20.2965 10.5285C20.2974 10.4174 20.3333 10.3094 20.3992 10.2197C20.4119 10.2036 20.4263 10.1888 20.4421 10.1757L20.4326 10.1696C20.389 9.62783 20.5163 8.69195 19.9271 8.51452C21.0388 7.13847 22.2635 6.88655 23.2902 7.72628C24.3571 7.78518 24.8721 9.31834 24.1468 10.1452ZM21.017 9.80662C20.9649 9.97364 20.9602 10.1517 21.0034 10.3213C21.0106 10.3446 21.0101 10.3696 21.0018 10.3926C20.9935 10.4156 20.978 10.4353 20.9576 10.4488C20.9372 10.4623 20.9129 10.4688 20.8884 10.4674C20.8639 10.4661 20.8405 10.4568 20.8218 10.4412C20.6857 10.326 20.6034 10.3152 20.568 10.3572C20.534 10.4096 20.5163 10.4708 20.517 10.5333C20.5128 10.6249 20.5245 10.7165 20.5517 10.8041C20.5979 10.9551 20.6877 11.079 20.7952 11.0479C20.8057 11.0444 20.8168 11.0425 20.8279 11.0425C20.8428 11.0421 20.8577 11.0447 20.8716 11.0501C20.8855 11.0554 20.8982 11.0634 20.909 11.0737C20.9198 11.0839 20.9285 11.0962 20.9345 11.1098C20.9406 11.1234 20.9439 11.138 20.9442 11.1529C20.9558 11.6269 21.1647 11.8077 21.4205 12.0265L21.4273 12.0319L21.5362 12.1267C21.6509 12.2306 21.7856 12.3103 21.9322 12.361C22.0298 12.3937 22.1314 12.4135 22.2342 12.4199C22.3104 12.4214 22.3865 12.4178 22.4622 12.4091C22.5649 12.3982 22.6662 12.3776 22.7649 12.3474C22.8897 12.2972 23.0032 12.2228 23.099 12.1287L23.2092 12.0244C23.4814 11.7712 23.6801 11.5843 23.642 11.1299C23.6402 11.1087 23.6444 11.0874 23.6542 11.0685C23.664 11.0496 23.679 11.0338 23.6974 11.023C23.7158 11.0122 23.7369 11.0067 23.7583 11.0073C23.7796 11.0079 23.8004 11.0144 23.8182 11.0262C23.8951 11.077 23.9713 11.0262 24.0277 10.9423C24.0895 10.8441 24.1288 10.7336 24.1427 10.6186C24.1613 10.5383 24.1515 10.4541 24.1148 10.3802C24.0876 10.345 24.0148 10.3592 23.8747 10.4655C23.8569 10.4806 23.8349 10.4899 23.8117 10.492C23.7885 10.4943 23.7651 10.4893 23.7448 10.4778C23.7246 10.4663 23.7083 10.4489 23.6983 10.428C23.6883 10.407 23.685 10.3834 23.6889 10.3606C23.7882 9.78224 23.7386 9.42467 23.6114 9.18631C23.5004 8.98315 23.3235 8.85786 23.1351 8.75832C22.7166 9.0766 22.4213 9.11248 22.1274 9.14906C21.8845 9.17884 21.643 9.20866 21.3225 9.42873C21.183 9.51888 21.0763 9.65138 21.0184 9.80662H21.017Z"
                  fill={
                    location.pathname === "/request" ? "#194AF5" : "#B7B7B7"
                  }
                />
                <path
                  d="M20.6101 31.2697C21.0784 31.2697 21.4608 31.6495 21.4608 32.1178C21.4608 32.5861 21.081 32.9659 20.6101 32.9659H9.97724C9.4335 32.9659 8.93919 32.7448 8.58016 32.3858C8.22114 32.0293 8 31.5376 8 30.9913V2.97699C8 2.43065 8.22114 1.93894 8.58016 1.57992C8.93919 1.22089 9.43089 0.999756 9.97724 0.999756H34.2504C34.7941 0.999756 35.2885 1.2235 35.6475 1.57992C36.0065 1.93894 36.2276 2.43065 36.2276 2.97699V17.0128C36.2276 17.4811 35.8478 17.8609 35.3795 17.8609C34.9112 17.8609 34.5314 17.4811 34.5314 17.0128V2.97699C34.5314 2.90154 34.5002 2.8313 34.4481 2.78187C34.3961 2.72984 34.3259 2.69862 34.253 2.69862H9.97724C9.90179 2.69862 9.83154 2.72984 9.77951 2.77927C9.73008 2.8339 9.69886 2.90154 9.69886 2.97699V30.9913C9.69886 31.0667 9.73008 31.137 9.78211 31.1864C9.83415 31.2385 9.90439 31.2697 9.97984 31.2697H20.6101ZM34.612 21.563C34.4741 21.4303 34.3154 21.3679 34.1333 21.3705C33.9486 21.3731 33.7925 21.4459 33.665 21.5812L32.6114 22.6791L35.5694 25.5357L36.6335 24.4274C36.761 24.2973 36.813 24.1308 36.8104 23.9487C36.8078 23.7692 36.7428 23.6027 36.6127 23.4804L34.612 21.563ZM29.9941 31.2228C29.6039 31.3477 29.2137 31.4752 28.826 31.6027C28.4358 31.7328 28.0455 31.8628 27.6579 31.9929C26.7395 32.2947 26.2244 32.4612 26.1151 32.4924C26.0111 32.5237 26.0709 32.0944 26.305 31.1942L27.0361 28.3767L31.6722 23.6469L34.6276 26.4905L29.9941 31.2228ZM16.2576 25.8089C15.7893 25.8089 15.4068 25.4238 15.4068 24.9477C15.4068 24.4716 15.7867 24.0866 16.2576 24.0866H22.0358C22.5041 24.0866 22.8865 24.4716 22.8865 24.9477C22.8865 25.4238 22.5067 25.8089 22.0358 25.8089H16.2576ZM16.2576 20.4261C15.7893 20.4261 15.4094 20.0463 15.4094 19.5754C15.4094 19.1071 15.7893 18.7272 16.2576 18.7272H27.7177C28.186 18.7272 28.5659 19.1071 28.5659 19.5754C28.5659 20.0437 28.186 20.4261 27.7177 20.4261H16.2576Z"
                  fill={
                    location.pathname === "/request" ? "#194AF5" : "#B7B7B7"
                  }
                />
              </g>
              <defs>
                <clipPath id="clip0_4185_12346">
                  <rect
                    width={45}
                    height={32}
                    fill="white"
                    transform="translate(0 0.588135)"
                  />
                </clipPath>
              </defs>
            </svg>
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography
                color={location.pathname === "/request" && "primary"}
                variant="body2"
              >
                {"Doctor Request"}
              </Typography>
            }
          />
        </ListItemButton>
      </ListItem> */}
      <ListItem key={"Template"} disablePadding>
        <ListItemButton
          selected={location.pathname === "/template"}
          onClick={() => {
            navigate("/template");
          }}
        >
          <ListItemIcon>
            <svg width={35} height={23} viewBox="0 0 45 33" fill="none">
              <g clipPath="url(#clip0_4185_12352)">
                <path
                  d="M4.55948 10.0554H32.329C32.7588 10.0554 33.1488 10.2306 33.431 10.5128C33.7133 10.7951 33.8888 11.1853 33.8888 11.6149V31.44C33.8888 31.8695 33.7136 32.2601 33.431 32.542C33.4063 32.567 33.3803 32.5902 33.3531 32.612C33.0784 32.8531 32.7202 32.9994 32.3293 32.9994H4.55948C4.12994 32.9994 3.73967 32.8243 3.45742 32.5423C3.17518 32.2604 3 31.8698 3 31.4403V11.6149C3 11.185 3.17518 10.7951 3.45742 10.5128C3.73935 10.2306 4.12962 10.0554 4.55948 10.0554ZM13.3693 2.85352C12.8574 2.85352 12.4424 2.43855 12.4424 1.92664C12.4424 1.41505 12.8574 0.999756 13.3693 0.999756H40.9988C41.5104 0.999756 41.925 1.41505 41.925 1.92664V21.4007C41.925 21.9126 41.5104 22.3276 40.9988 22.3276C40.4865 22.3276 40.0719 21.9126 40.0719 21.4007V2.85352H13.3693ZM9.18694 7.54148C8.67503 7.54148 8.26037 7.12651 8.26037 6.6146C8.26037 6.10269 8.67534 5.68771 9.18694 5.68771H36.8164C37.328 5.68771 37.7433 6.10269 37.7433 6.6146V26.0887C37.7433 26.6006 37.328 27.0156 36.8164 27.0156C36.3048 27.0156 35.8895 26.6006 35.8895 26.0887V7.54148H9.18694ZM32.035 11.9089H4.85345V31.1463H32.035V11.9089Z"
                  fill={
                    location.pathname === "/template" ? "#194AF5" : "#B7B7B7"
                  }
                />
              </g>
              <defs>
                <clipPath id="clip0_4185_12352">
                  <rect
                    width={45}
                    height={32}
                    fill="white"
                    transform="translate(0 0.588135)"
                  />
                </clipPath>
              </defs>
            </svg>
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography
                color={location.pathname === "/template" && "primary"}
                variant="body2"
              >
                {"Template"}
              </Typography>
            }
          />
        </ListItemButton>
      </ListItem>
      <ListItem key={"Settings"} disablePadding>
        <ListItemButton
          selected={location.pathname === "/settings"}
          onClick={() => {
            navigate("/settings");
          }}
        >
          <ListItemIcon>
            <svg width={28} height={28} viewBox="0 0 32 33" fill="none">
              <g clipPath="url(#clip0_4185_12361)">
                <path
                  d="M16.256 26.3519C16.0885 26.3519 15.9198 26.3519 15.756 26.3519L11.7498 28.5881C10.1902 28.0635 8.74363 27.2493 7.48604 26.1881L7.47104 21.6881C7.38229 21.5481 7.29854 21.4069 7.22104 21.2619L3.23729 18.9931C2.92351 17.406 2.92351 15.7728 3.23729 14.1856L7.21729 11.9231C7.29854 11.7794 7.38229 11.6369 7.46729 11.4969L7.48729 6.99688C8.74374 5.93269 10.1899 5.11544 11.7498 4.58813L15.7498 6.82438C15.9173 6.82438 16.086 6.82438 16.2498 6.82438L20.2498 4.58813C21.8094 5.11274 23.256 5.92699 24.5135 6.98813L24.5285 11.4881C24.6173 11.6281 24.701 11.7694 24.7785 11.9144L28.7598 14.1819C29.0736 15.769 29.0736 17.4022 28.7598 18.9894L24.7798 21.2519C24.6985 21.3956 24.6148 21.5381 24.5298 21.6781L24.5098 26.1781C23.2542 27.2425 21.8089 28.0602 20.2498 28.5881L16.256 26.3519Z"
                  stroke={
                    location.pathname === "/settings" ? "#194AF5" : "#B7B7B7"
                  }
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M16 21.5881C18.7614 21.5881 21 19.3496 21 16.5881C21 13.8267 18.7614 11.5881 16 11.5881C13.2386 11.5881 11 13.8267 11 16.5881C11 19.3496 13.2386 21.5881 16 21.5881Z"
                  stroke={
                    location.pathname === "/settings" ? "#194AF5" : "#B7B7B7"
                  }
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_4185_12361">
                  <rect
                    width={32}
                    height={32}
                    fill="white"
                    transform="translate(0 0.588135)"
                  />
                </clipPath>
              </defs>
            </svg>
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography
                color={location.pathname === "/settings" && "primary"}
                variant="body2"
              >
                {"Settings"}
              </Typography>
            }
          />
        </ListItemButton>
      </ListItem>

      <ListItem
        key={"Logout"}
        disablePadding
        sx={{
          marginTop: "auto !important",
          flexShrink: 0,
        }}
      >
        <ListItemButton
          sx={{
            "&:hover": {
              color: "red",
            },
          }}
          onClick={() => logout()}
        >
          <ListItemIcon>
            <svg width={28} height={28} viewBox="0 0 33 33" fill="none">
              <g id="SignOut" clipPath="url(#clip0_5304_2696)">
                <path
                  id="Vector"
                  d="M14.5 5.58813H6.5V27.5881H14.5"
                  stroke="#F27878"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  id="Vector_2"
                  d="M14.5 16.5881H28.5"
                  stroke="#F27878"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  id="Vector_3"
                  d="M23.5 11.5881L28.5 16.5881L23.5 21.5881"
                  stroke="#F27878"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_5304_2696">
                  <rect
                    width="32"
                    height="32"
                    fill="white"
                    transform="translate(0.5 0.588135)"
                  />
                </clipPath>
              </defs>
            </svg>
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography variant="body2" color={"#F27878"}>
                {"Logout"}
              </Typography>
            }
          />
        </ListItemButton>
      </ListItem>
    </List>
  );
  return <Box className="sidemenu">{drawer}</Box>;
}

export default Navbar;
